import { useMutation, UseMutationResult } from "react-query"
import { api } from "../../../api"
import { localConfig } from "../../../../Configs/localConfig"
import { errorAlert, loadingAlert, successAlert } from "../../../../utils/alert"

interface PropsDeleteMicrorganismos {
  cod: number
  microrganismos_remover?: number[]
  setDeuErro: React.Dispatch<React.SetStateAction<string>>
}
interface PropsDeletarBioInsumo {
  cod_bioInsumo: number
  refetch_deletar: () => void
}

export const usePutRemoverMicrorganismos = (): {
  carregando_remover_microrganismos: boolean
  mutate_remover_microrganismos: (params: PropsDeleteMicrorganismos) => void
  isSuccess_remover_microrganismos: boolean
} => {
  const mutation: UseMutationResult<Response, Error, PropsDeleteMicrorganismos> = useMutation(
    async (params: PropsDeleteMicrorganismos) => {
      const { cod, microrganismos_remover, setDeuErro } = params

    //  propriedades_remover?.length <= 0 &&  loadingAlert({ msg: 'Removendo...', id: 'remove_ativo' })

      return api
        .put(`recomendacao/bioinsumo/${cod}?codConta=${localConfig()?.conta}&codCliente=${localConfig()?.codCliente}`, {
          microrganismos_remover: microrganismos_remover
        })
        .then((response: any) => {
          successAlert('Microrganismos removido com sucesso!', 5000, 'remover')
          setDeuErro('sucesso')
          return response
        })
        .catch((error: any) => {
          if (error?.response?.data?.error[0]?.msg) {
           error.response.data.error.forEach((data) => {
               errorAlert(data?.msg[0] ?? 'Falha ao remover microrganismo!', 5000, 'remover')
               setDeuErro('erro')
            })
           
          } else {
            errorAlert(
              error.response.data.error ?? 'Falha ao remover microrganismo!',
              5000,
              'teste'
            )
            setDeuErro('erro')
          }

          throw error
        })
       
    }
  )

  return {
    carregando_remover_microrganismos: mutation.isLoading,
    mutate_remover_microrganismos: mutation.mutate,
    isSuccess_remover_microrganismos: mutation.isSuccess,
  }
}

export const useDeletarBioInsumo = (): {
carregando_deletar_bioInsumo: boolean
mudate_deletar_bioInsumo: (params: PropsDeletarBioInsumo) => void
} => {
const mutation: UseMutationResult<Response, Error, PropsDeletarBioInsumo> = useMutation(
  async (params: PropsDeletarBioInsumo) => {
    const {
      cod_bioInsumo,
     refetch_deletar
    } = params

    const config = localConfig()

    loadingAlert({ msg: 'Excluindo...', id: 'delete_bioInsumo' })

    return api
      .delete(
        `recomendacao/bioinsumo/${cod_bioInsumo}?codConta=${config.conta}&codCliente=${config?.codCliente}`
      )
      .then((response: any) => {
        successAlert('Excluído com sucesso!', 5000, 'delete_bioInsumo')
        refetch_deletar?.()
        return response
      })
      .catch((error: Error) => {
        //@ts-ignore
        let error_response = error?.response?.data
        errorAlert(error_response?.error ?? 'Falha ao excluir bioInsumo', 5000, 'delete_bioInsumo')

        throw error
      })
  }
)

return {
  carregando_deletar_bioInsumo: mutation.isLoading,
  mudate_deletar_bioInsumo: mutation.mutate,
}
}